import { Eip1193Bridge } from "@ethersproject/experimental";
import { JsonRpcProvider } from "@ethersproject/providers";
import { EIP1193 as Connector } from "@web3-react/eip1193";
import { BaseConnectorProps } from "./types";
import { useCallback, useEffect, useMemo } from "react";
import {
  useConnectEagerly,
  useConnector,
  useInitializeConnector,
  useSwitchChain,
} from "../hooks";
import { Web3ConnectionType } from "../types";

class Eip1193BridgeWithoutAccounts extends Eip1193Bridge {
  request(request: { method: string; params?: unknown[] }): Promise<unknown> {
    if (
      request.method === "eth_requestAccounts" ||
      request.method === "eth_accounts"
    )
      return Promise.resolve([]);
    return super.request(request);
  }
}

export const EIP1193 = ({
  options,
  onStateUpdate,
  chainId,
  onConnectorUpdate,
}: BaseConnectorProps<Connector>) => {
  const provider = useMemo(() => {
    const ethersProvider = new JsonRpcProvider(
      options.urls[options.defaultChainId][0],
      1,
    );
    return new Eip1193BridgeWithoutAccounts(
      ethersProvider.getSigner(),
      ethersProvider,
    );
  }, [options.defaultChainId, options.urls]);

  const connector = useInitializeConnector(
    Web3ConnectionType.EIP1193,
    useCallback(
      (actions) => {
        return new Connector({ actions, provider });
      },
      [provider],
    ),
  );

  useEffect(() => {
    onConnectorUpdate(connector.connector);
  }, [connector.connector, onConnectorUpdate]);

  const state = useConnector(connector, onStateUpdate);

  useConnectEagerly(connector.connector, Web3ConnectionType.EIP1193);

  useSwitchChain(connector.connector, state, chainId || options.defaultChainId);

  return null;
};
